// Copyright 2020 The Nakama Authors
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

export interface RpcFunction {
  id: string;
  runtime: string;
  http_key?: string;
}

export interface RpcFunctionList {
  functions: RpcFunction[];
}

export interface RpcCallRequest {
  id: string;
  body?: string;
  http_key?: string;
  user_id?: string;
}

export interface RpcCallResponse {
  id: string;
  body: string;
  user_id?: string;
}

export interface ApiEndpoint {
  method: string;
  path: string;
  description?: string;
  parameters?: ApiParameter[];
  body_schema?: string;
  response_schema?: string;
}

export interface ApiParameter {
  name: string;
  type: string;
  required: boolean;
  description?: string;
  default_value?: string;
}

export interface ApiExplorerRequest {
  method: string;
  path: string;
  headers?: Record<string, string>;
  query_params?: Record<string, string>;
  body?: string;
}

export interface ApiExplorerResponse {
  status: number;
  status_text: string;
  headers: Record<string, string>;
  body: string;
  duration: number;
}

export interface ApiExplorerHistory {
  id: string;
  timestamp: string;
  request: ApiExplorerRequest;
  response?: ApiExplorerResponse;
  name?: string;
}

export enum HttpMethod {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  DELETE = 'DELETE',
  PATCH = 'PATCH',
  HEAD = 'HEAD',
  OPTIONS = 'OPTIONS',
}

export interface RpcSearchFilters {
  id?: string;
  runtime?: string;
}
